import { httpClient } from '../httpClient';

export const assessmentApi = {
  getAll: (params) =>
    httpClient.get('/assessments/', { params }),

  getById: (id) =>
    httpClient.get(`/assessments/${id}`),

  create: (data) =>
    httpClient.post('/assessments/', data),

  update: (id, data) =>
    httpClient.put(`/assessments/${id}`, data),

  delete: (id) =>
    httpClient.delete(`/assessments/${id}`),

  exportPdf: (id, language) =>
    httpClient.post(`/assessments/${id}/export-pdf`, { language }, { responseType: 'blob' }),

  exportExcel: (id) =>
    httpClient.post(`/assessments/${id}/export-excel`, {}, { responseType: 'blob' }),

  exportManagementReport: (language) =>
    httpClient.post('/assessments/export-management-report', { language }, { responseType: 'blob' }),

  advanceToDpoReview: (id, dpoUserId) =>
    httpClient.post(`/assessments/${id}/advance-dpo-review`, { dpoUserId }),

  submitDpoOpinion: (id, data) =>
    httpClient.post(`/assessments/${id}/dpo-opinion`, data),
  // SDAIA Art. 16 consultation wizard (T058)
  sdaiaPrepare: (id) =>
    httpClient.post(`/assessments/${id}/sdaia/prepare`, {}),

  sdaiaSubmit: (id, data) =>
    httpClient.post(`/assessments/${id}/sdaia/submit`, data),

  sdaiaRecordOutcome: (id, data) =>
    httpClient.post(`/assessments/${id}/sdaia/record-outcome`, data),

  // Phase 8 — US-1: Classification-Driven DPIA Pre-Fill (T065, T065b)
  prefillFromClassification: (classificationId) =>
    httpClient.post(`/assessments/pre-fill/${classificationId}`, {}),

  getRopaCandidates: (params) =>
    httpClient.get('/assessments/ropa-candidates', { params }),

  // "No DPO assigned" guardrail signal — { has_dpo, dpo_count }.
  getDpoAvailability: () =>
    httpClient.get('/assessments/dpo-availability'),

  // Phase 14 — US-5: Command Center (T116, T117, T117b, T120)
  getCommandCenter: () =>
    httpClient.get('/assessments/command-center'),

  getRopaCoverage: () =>
    httpClient.get('/assessments/ropa-coverage'),

  prefillFromRopa: (ropaId) =>
    httpClient.post(`/assessments/pre-fill-from-ropa/${ropaId}`, {}),

  // Spec 031 FR-011 — re-pre-fill an EXISTING DPIA against the current ROPA
  // version. The remedy the DPIA_OUT_OF_DATE activation refusal names:
  // rewrites the register-derived facts, re-stamps ropaVersion and returns the
  // assessment to dpo_review, preserving every answer the DPO authored.
  refreshFromRopa: (assessmentId) =>
    httpClient.post(`/assessments/${assessmentId}/refresh-from-ropa`, {}),

  // Phase 18 — US-14: Regulatory Calendar + Bulk Operations (T142, T143)
  getCalendar: (year, month) =>
    httpClient.get('/assessments/calendar', { params: { year, month } }),

  bulkAction: (ids, action, payload = {}) =>
    httpClient.post('/assessments/bulk', { ids, action, payload }),

  // Phase 19 — US-15: Comments + SDAIA Inspection Packet (T151, T153)
  getComments: (id, params) =>
    httpClient.get(`/assessments/${id}/comments`, { params }),

  postComment: (id, body) =>
    httpClient.post(`/assessments/${id}/comments`, { body }),

  exportSdaiaPackage: (ids) =>
    httpClient.post('/assessments/export-sdaia-package', { ids }, { responseType: 'blob' }),

  // T135a — Sector overlay checklist (FR-055)
  getSectorProfile: (id) =>
    httpClient.get(`/assessments/${id}/sector-profile`),

  // Slice 3 — dedicated action-queue endpoint (T119 rewire)
  getActionQueue: (params) =>
    httpClient.get('/assessments/action-queue', { params }),
};
